import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import get from 'lodash/get';
import { withMfeComponents } from 'yoda-app-shell/lib/mfe/MfeLoader/withMfeComponents';
import { federatedComponents } from 'config/federatedComponents';
import Loader from 'yoda-core-components/lib/components/Loader/Loader';
import LayoutHelmet from 'yoda-site-components/lib/components/CAMNav/LayoutHelmet';
import Routing from 'yoda-account-components/lib/helpers/Routing/Routing';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import { YodaContext } from 'yoda-site-components/lib/components/ContextProvider/ContextProvider';
import EmailNotificationPreferences from './EmailNotificationPreferences';
import MobileNotificationPreferences from './MobileNotificationPreferences';

const defaultObject = {};

export class Preferences extends Component {
    static defaultProps = {
        notification: {},
        location: {
            search: {},
            pathname: '',
        },
    };

    static propTypes = {
        notification: PropTypes.objectOf(PropTypes.object),
        actions: PropTypes.objectOf(PropTypes.object).isRequired,
        messagesTexts: PropTypes.objectOf(PropTypes.object).isRequired,
        camActions: PropTypes.objectOf(PropTypes.object).isRequired,
        location: PropTypes.shape({
            pathname: PropTypes.string.isRequired,
            search: PropTypes.string.isRequired,
        }),
        featureFlags: PropTypes.objectOf(PropTypes.any).isRequired,
        redirectAction: PropTypes.objectOf(PropTypes.func).isRequired,
        headers: PropTypes.objectOf.isRequired,
        preferences: PropTypes.objectOf(PropTypes.any).isRequired,
    };

    static contextType = YodaContext;

    static childContextTypes = {
        featureFlags: PropTypes.objectOf(PropTypes.any).isRequired,
        preferences: PropTypes.objectOf(PropTypes.any).isRequired,
    };

    constructor(props) {
        super();
        const notificationObj = props.notification.response || {};

        this.state = {
            notificationObj,
            emailSubscriptionObj: { ...get(notificationObj, 'communication.email', {}) },
            feedbackEmailObj: { ...get(notificationObj, 'notifications', {}) },
            mobileSubscriptionObj: { ...get(notificationObj, 'communication.phones[0]', {}) },
            orderStatusSubscriptionObj: { ...get(notificationObj, 'communication.phones[1]', {}) },
            marketingPhValid: true,
            orderPhValid: true,
            emailSubscribeErrorText: '',
            marketErrorText: '',
            orderSubscribeErrorText: '',
            emptyMarketInputError: false,
            emptyOrderInputError: false,
            showMessageBox: false,
            warningMessage: true,
            enableEmailSubscriptionSaveButton: false,
            enableFeedbackEmailSubscriptionSaveButton: false,
            enableMobileSubscriptionForMarketing: false,
            enableMobileSubscriptionForOrderStatus: false,
            clearInputError: false,
            isEmailNotificationsActive: true,
            isMobileNotificationsActive: false,
            submitType: '',
            orderNumberText: '',
            marketingNumberText: '',
        };
    }

    getChildContext() {
        return {
            featureFlags: this.props.featureFlags,
            preferences: this.props.preferences,
        };
    }

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillMount() {
        if (__SERVER__) {
            const {
                location: { pathname },
                headers,
                redirectAction,
            } = this.props;
            const userState = get(headers, 'cookies.DP_USER_STATE', '0');
            userState !== '1' && redirectAction.setRedirectUrl({ url: `/signin?next=${pathname}` });
        }
    }

    componentDidMount() {
        const {
            location: { pathname },
        } = this.props;
        if (Routing.ensureRestrictedRoute(pathname, true)) {
            const analyticsData = {
                trackEvent: 'digitalDataReady',
                pageName: 'notifications page',
            };
            this.props.camActions.camAnalyticsAction(analyticsData);
        }
        if (!this.props.notification.isSuccess) {
            this.props.actions.getNotification();
        }
        /* eslint-disable react/no-did-mount-set-state */
        this.setState({ hasMounted: true });
    }

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { notification } = nextProps;
        const { submitType } = this.state;
        let messageTitle = '';
        let messageContent = '';
        let messageType = '';
        if (nextProps.notification.response) {
            this.setState({
                notificationObj: nextProps.notification.response,
                emailSubscriptionObj: {
                    ...get(nextProps.notification.response, 'communication.email', {}),
                },
                feedbackEmailObj: { ...get(nextProps.notification.response, 'notifications', {}) },
                mobileSubscriptionObj: {
                    ...get(nextProps.notification.response, 'communication.phones[0]', {}),
                },
                orderStatusSubscriptionObj: {
                    ...get(nextProps.notification.response, 'communication.phones[1]', {}),
                },
            });
        }
        if (this.props.notification.requestFrom !== notification.requestFrom) {
            if (notification.isSuccess) {
                const {
                    communication: { phones },
                } = notification.response;
                const orderTextData = phones[1] || null;
                this.setState({ orderNumberText: '', marketingNumberText: '' });
                if (
                    submitType === 'orderStatusSubscription' &&
                    orderTextData &&
                    orderTextData.status === null
                ) {
                    messageContent = get(
                        this.props.messagesTexts,
                        'mobileSubscriptionSuccessMessage'
                    );
                }
                messageTitle = get(this.props.messagesTexts, 'successMessage');
                messageType = 'success';
            } else {
                messageTitle = get(notification, 'error.errorMessage', '');
                messageType = 'error';
            }
            this.resetButtons();
            this.context?.showMessageBox
                ? this.context.showMessageBox(messageType, messageTitle, messageContent)
                : this.showMessageBox(messageType, messageTitle, messageContent);
        }
    }

    setEmailNotificationsActive = (isEmailNotificationsActive) => {
        this.setState({ isEmailNotificationsActive }, () => {
            if (this.state.isEmailNotificationsActive) {
                this.setState({ isMobileNotificationsActive: false });
            }
        });
        window.scrollTo(0, 0);
    };

    setMobileNotificationsActive = (isMobileNotificationsActive) => {
        this.setState({ isMobileNotificationsActive }, () => {
            if (this.state.isMobileNotificationsActive) {
                this.setState({ isEmailNotificationsActive: false });
            }
        });
        window.scrollTo(0, 0);
    };

    submitNotification = (type) => {
        // NOSONAR
        const {
            emailSubscribeErrorText,
            orderPhValid,
            marketingPhValid,
            notificationObj,
            emailSubscriptionObj,
            feedbackEmailObj,
            mobileSubscriptionObj,
            orderStatusSubscriptionObj,
            orderNumberText,
            marketingNumberText,
        } = this.state;
        this.setState({ submitType: type });
        const analyticsData = {
            trackEvent: 'updateNotificationOptins',
        };
        let isValid = type === 'emailSubscription' || type === 'feedbackEmailSubscription';
        let newNotification = {};
        switch (type) {
            case 'emailSubscription':
                newNotification = {
                    ...notificationObj,
                    communication: {
                        ...notificationObj.communication,
                        email: emailSubscriptionObj,
                    },
                };
                if (
                    notificationObj?.communication?.phones[1] &&
                    notificationObj?.communication?.phones[1].number !== ''
                ) {
                    newNotification.communication.phones[1] =
                        notificationObj?.communication?.phones[1];
                    newNotification.communication.phones[1].status =
                        notificationObj?.communication?.phones[1].status === undefined ||
                        notificationObj?.communication?.phones[1].status === 'undefined'
                            ? null
                            : notificationObj?.communication?.phones[1].status;
                }
                analyticsData.preferences = [
                    {
                        optinType: 'email',
                        optinFlag: emailSubscriptionObj.status ? 'yes' : 'no',
                        notificationType: 'marketing',
                        source: 'my account preferences',
                    },
                ];
                /* trigger CAM analytics for new preferences page */
                this.props.camActions.promotionalAnalyticsAction(analyticsData);
                break;
            case 'feedbackEmailSubscription':
                newNotification = { ...notificationObj, notifications: { ...feedbackEmailObj } };
                break;
            case 'mobileSubscription':
                newNotification = {
                    ...notificationObj,
                    communication: {
                        ...notificationObj.communication,
                        phones: [mobileSubscriptionObj],
                    },
                };
                if (
                    notificationObj?.communication?.phones[1] &&
                    notificationObj?.communication?.phones[1].number !== ''
                ) {
                    newNotification.communication.phones[1] =
                        notificationObj?.communication?.phones[1];
                    newNotification.communication.phones[1].status =
                        notificationObj?.communication?.phones[1].status === undefined ||
                        notificationObj?.communication?.phones[1].status === 'undefined'
                            ? null
                            : notificationObj?.communication?.phones[1].status;
                }
                if (notificationObj?.communication?.phones[0]?.number && marketingNumberText) {
                    notificationObj.communication.phones[0].number = marketingNumberText;
                }
                analyticsData.preferences = [
                    {
                        optinType: 'sms',
                        optinFlag: mobileSubscriptionObj.status ? 'yes' : 'no',
                        notificationType: 'marketing',
                        source: 'my account preferences',
                    },
                ];
                this.props.camActions.promotionalAnalyticsAction(analyticsData);
                break;
            case 'orderStatusSubscription':
                newNotification = {
                    ...notificationObj,
                    communication: {
                        ...notificationObj.communication,
                        phones: [
                            notificationObj.communication.phones[0] || {
                                id: 'marketing',
                                number: '',
                                status: null,
                            },
                            orderStatusSubscriptionObj,
                        ],
                    },
                };
                if (notificationObj?.communication?.phones[1]?.number && orderNumberText) {
                    notificationObj.communication.phones[1].number = orderNumberText;
                }
                break;
            default:
                newNotification = {};
                break;
        }
        const { communication: { phones = [] } = {} } = newNotification;
        const [marketingText = {}, orderText = {}] = phones;
        const validationCheck = {};
        if (type === 'mobileSubscription') {
            if (marketingText.status && !marketingPhValid) {
                isValid = false;
            } else if (marketingText.status && !marketingText.number) {
                this.setState({ marketingPhValid: false, emptyMarketInputError: true });
                isValid = false;
            } else {
                isValid = true;
                validationCheck.marketingPhValid = true;
            }
            // allow to check for both undefined and null NOT false
            if (marketingText.status === null && marketingText.number) {
                validationCheck.marketErrorText = get(
                    this.props.messagesTexts,
                    'invalidSelectionMessage'
                );
                isValid = false;
            } else {
                validationCheck.marketErrorText = '';
            }
        }
        if (type === 'orderStatusSubscription') {
            if (orderText.status && !orderPhValid) {
                isValid = false;
            } else if (orderText.status && !orderText.number) {
                isValid = false;
                this.setState({ orderPhValid: false, emptyOrderInputError: true });
            } else {
                isValid = true;
                validationCheck.orderPhValid = true;
            }

            if (orderText.status === undefined && orderText.number) {
                validationCheck.orderSubscribeErrorText = get(
                    this.props.messagesTexts,
                    'invalidSelectionMessage'
                );
                isValid = false;
            } else {
                validationCheck.orderSubscribeErrorText = '';
            }
        }

        /* istanbul ignore next: tough to test */
        if (isValid && emailSubscribeErrorText === '') {
            validationCheck.messageTitle = '';
            const {
                response: {
                    communication: { phones: [, { propsPhoneStatus } = {}] = [{}, {}] },
                } = {
                    communication: { phones: [{}, {}] },
                },
            } = this.props.notification;
            if (!propsPhoneStatus && orderText?.status) {
                orderText.status = null;
            }
            this.context?.hideMessageBox ? this.context.hideMessageBox() : this.hideMessageBox();
            this.setState(validationCheck, () => {
                this.props.actions.updateNotification(newNotification);
                window.scrollTo(0, 0);
            });
        } else {
            const messageTitle = get(this.props.messagesTexts, 'fixErrorsMessage');
            const messageType = 'error';
            this.context?.showMessageBox
                ? this.context.showMessageBox(messageType, messageTitle)
                : this.showMessageBox(messageType, messageTitle);
            this.setState(validationCheck);
            window.scrollTo(0, 0);
        }
    };

    checkboxClicked = (event) => {
        const elementId = event.currentTarget.id;
        const elementChecked = event.currentTarget.checked;
        const feedbackEmailObj = { ...this.state.feedbackEmailObj };

        if (elementId === 'survey') {
            this.setState({
                enableFeedbackEmailSubscriptionSaveButton: true,
                feedbackEmailObj: {
                    ...feedbackEmailObj,
                    surveyParticipationReminder: {
                        ...feedbackEmailObj.surveyParticipationReminder,
                        email: {
                            ...feedbackEmailObj.surveyParticipationReminder.email,
                            enabled: elementChecked,
                        },
                    },
                },
            });
        } else if (elementId === 'rating') {
            this.setState({
                enableFeedbackEmailSubscriptionSaveButton: true,
                feedbackEmailObj: {
                    ...feedbackEmailObj,
                    ratingReviewNotification: {
                        ...feedbackEmailObj.ratingReviewNotification,
                        email: {
                            ...feedbackEmailObj.ratingReviewNotification.email,
                            enabled: elementChecked,
                        },
                    },
                },
            });
        }
    };

    listenToInput = (valid, phoneNumber, name) => {
        const orderStatusSubscriptionObj = { ...this.state.orderStatusSubscriptionObj };
        const mobileSubscriptionObj = { ...this.state.mobileSubscriptionObj };
        this.setState({ clearInputError: false });
        if (name === 'marketingNumber') {
            if ((phoneNumber && valid) || (!phoneNumber && !valid)) {
                mobileSubscriptionObj.id = 'marketing';
                mobileSubscriptionObj.number = phoneNumber;
                this.setState({
                    enableMobileSubscriptionForMarketing: true,
                    marketingPhValid: true,
                    mobileSubscriptionObj,
                    emptyMarketInputError: false,
                    marketingNumberText: phoneNumber,
                });
            } else {
                mobileSubscriptionObj.id = 'marketing';
                mobileSubscriptionObj.number = '';
                this.setState({
                    enableMobileSubscriptionForMarketing: false,
                    marketingPhValid: false,
                    emptyMarketInputError: true,
                    mobileSubscriptionObj,
                });
            }
        }
        if (name === 'orderNumber') {
            if ((phoneNumber && valid) || (!phoneNumber && !valid)) {
                orderStatusSubscriptionObj.id = 'transaction';
                orderStatusSubscriptionObj.number = phoneNumber;
                this.setState({
                    enableMobileSubscriptionForOrderStatus: true,
                    orderPhValid: true,
                    orderStatusSubscriptionObj,
                    emptyOrderInputError: false,
                    orderNumberText: phoneNumber,
                });
            } else {
                orderStatusSubscriptionObj.id = 'transaction';
                orderStatusSubscriptionObj.number = '';
                this.setState({
                    enableMobileSubscriptionForOrderStatus: false,
                    orderPhValid: false,
                    emptyOrderInputError: true,
                    orderStatusSubscriptionObj,
                });
            }
        }
    };

    emailButtonClicked = (isSubscribed) => {
        // eslint-disable-next-line react/no-access-state-in-setstate
        const notification = { ...this.state.emailSubscriptionObj };
        notification.status = isSubscribed;
        this.setState({
            enableEmailSubscriptionSaveButton: true,
            emailSubscriptionObj: notification,
            emailSubscribeErrorText: '',
        });
    };

    marketButtonClicked = (isSubscribed) => {
        // eslint-disable-next-line react/no-access-state-in-setstate
        const newNotification = { ...this.state.mobileSubscriptionObj };
        newNotification.status = isSubscribed;
        this.setState({
            clearInputError: false,
            enableMobileSubscriptionForMarketing: true,
            mobileSubscriptionObj: newNotification,
            marketErrorText: '',
        });
    };

    orderButtonClicked = (isSubscribed) => {
        // eslint-disable-next-line react/no-access-state-in-setstate
        const newNotification = { ...this.state.orderStatusSubscriptionObj };
        newNotification.status = isSubscribed;
        this.setState({
            clearInputError: false,
            enableMobileSubscriptionForOrderStatus: true,
            orderStatusSubscriptionObj: newNotification,
            orderSubscribeErrorText: '',
        });
    };

    showMessageBox = (messageType, messageTitle, messageContent) => {
        this.setState({
            messageType,
            messageTitle,
            messageContent,
            showMessageBox: true,
        });
    };

    hideMessageBox = () => {
        this.setState({
            messageType: '',
            messageTitle: '',
            messageContent: '',
            showMessageBox: false,
        });
    };

    closeMessage = () => {
        this.setState({
            warningMessage: false,
        });
    };

    resetButtons = () => {
        this.setState({
            enableEmailSubscriptionSaveButton: false,
            enableFeedbackEmailSubscriptionSaveButton: false,
            enableMobileSubscriptionForMarketing: false,
            enableMobileSubscriptionForOrderStatus: false,
            clearInputError: true,
        });
    };

    render() {
        const {
            messageTitle,
            messageType,
            showMessageBox,
            messageContent,
            emailSubscribeErrorText,
            marketErrorText,
            orderSubscribeErrorText,
            emptyMarketInputError,
            emptyOrderInputError,
            warningMessage,
            emailSubscriptionObj,
            feedbackEmailObj: { surveyParticipationReminder, ratingReviewNotification },
            mobileSubscriptionObj,
            orderStatusSubscriptionObj,
            hasMounted,
            enableEmailSubscriptionSaveButton,
            enableFeedbackEmailSubscriptionSaveButton,
            enableMobileSubscriptionForMarketing,
            enableMobileSubscriptionForOrderStatus,
            clearInputError,
            isMobileNotificationsActive,
            isEmailNotificationsActive,
        } = this.state;

        const { messagesTexts, notification, featureFlags, preferences } = this.props;
        const { MessageBox } = this.props.mfeComponents || {};
        const checkboxConfigSurvey = {
            id: 'survey',
            'data-automation-id': 'survey',
            checked: get(surveyParticipationReminder, 'email.enabled'),
        };
        const checkboxConfigRating = {
            id: 'rating',
            'data-automation-id': 'rating',
            checked: get(ratingReviewNotification, 'email.enabled'),
        };
        defaultObject.title = 'Preferences';

        return (
            <>
                <LayoutHelmet layoutState={defaultObject} />
                <div>
                    {notification.isLoading && (
                        <Loader keepOverlay automationId="test-automation-loader-1" />
                    )}
                    {showMessageBox && MessageBox && (
                        <MessageBox
                            showMessage={showMessageBox}
                            type={messageType}
                            level="section"
                            title={messageTitle}
                            data-automation-id="at-accPO-InlineErrorMsg"
                            hasClose
                            onClose={this.hideMessageBox}
                            theme={dt(['!mb-6'])}
                        >
                            <div>{messageContent}</div>
                        </MessageBox>
                    )}
                    {hasMounted && (
                        <>
                            <EmailNotificationPreferences
                                marketingEmail={emailSubscriptionObj}
                                checkboxConfigRating={checkboxConfigRating}
                                checkboxConfigSurvey={checkboxConfigSurvey}
                                emailSubscribeErrorText={emailSubscribeErrorText}
                                emailButtonClicked={this.emailButtonClicked}
                                checkboxClicked={this.checkboxClicked}
                                messagesTexts={messagesTexts}
                                featureFlags={featureFlags}
                                submitNotification={this.submitNotification}
                                isEmailNotificationsActive={isEmailNotificationsActive}
                                setEmailNotificationsActive={this.setEmailNotificationsActive}
                                enableEmailSubscriptionSaveButton={
                                    enableEmailSubscriptionSaveButton
                                }
                                enableFeedbackEmailSubscriptionSaveButton={
                                    enableFeedbackEmailSubscriptionSaveButton
                                }
                            />
                            <MobileNotificationPreferences
                                marketingText={mobileSubscriptionObj}
                                orderText={orderStatusSubscriptionObj}
                                emptyMarketInputError={emptyMarketInputError}
                                emptyOrderInputError={emptyOrderInputError}
                                marketErrorText={marketErrorText}
                                orderSubscribeErrorText={orderSubscribeErrorText}
                                marketButtonClicked={this.marketButtonClicked}
                                orderButtonClicked={this.orderButtonClicked}
                                listenToInput={this.listenToInput}
                                messagesTexts={messagesTexts}
                                closeMessage={this.closeMessage}
                                warningMessage={warningMessage}
                                submitNotification={this.submitNotification}
                                isMobileNotificationsActive={isMobileNotificationsActive}
                                setMobileNotificationsActive={this.setMobileNotificationsActive}
                                enableMobileSubscriptionForMarketing={
                                    enableMobileSubscriptionForMarketing
                                }
                                enableMobileSubscriptionForOrderStatus={
                                    enableMobileSubscriptionForOrderStatus
                                }
                                clearInputError={clearInputError}
                                featureFlags={featureFlags}
                                preferences={preferences}
                                notification={notification}
                            />
                        </>
                    )}
                </div>
            </>
        );
    }
}

export default withMfeComponents(['MessageBox'], federatedComponents)(Preferences);
